import React, { useState, useEffect } from 'react';
import {
    Grid,
} from '@mui/material';

import {
    ActionBox,
} from '../Common';
import Loading from '../Loading';
import { DetailPanel, DetailPanelData } from "../Common/DetailPanel";
import { GetLocationCodes } from "../../CodesCache";
import '../Common/Common.css';
import { FormatDate } from '../../utils';

const LocationHeader = (props) => {
    const [loading, setLoading] = useState(true);
    const [codes, setCodes] = useState([]);

    const fetchData = async () => {
        const data = await GetLocationCodes();
        setCodes(data);
        setLoading(false);
    };

    useEffect(() => {
        fetchData();
    }, []);

    const formatLatLong = () => {
        if (props.data.location.lat != 0 && props.data.location.long != 0) {
            //setIsvalidLatLon(true)
            return `${props.data.location.lat},${props.data.location.long}`
        }
        return 'N/A';
    };

    const formatAddress = () => {
        if (props.data.location.physicalStreet != null && props.data.location.physicalState != null && props.data.location.physicalZip != null && props.data.location.physicalCountry != null && props.data.location.physicalCity) {
            return `${props.data.location.physicalStreet}, ${props.data.location.physicalCity}, ${props.data.location.physicalState} ${props.data.location.physicalZip}, ${props.data.location.physicalCountry}`
        }
        return "N/A";
    };

    const openLatLongMap = () => {
        if (props.data.location.lat != 0 && props.data.location.long != 0) {
            let URL = `https://www.google.com/maps/search/?api=1&query=${props.data.location.lat},${props.data.location.long}`
            window.open(URL, '_blank');
        }
        return 'N/A';
    };

    const openAddressMap = () => {
        if (props.data.location.physicalStreet != null && props.data.location.physicalState != null && props.data.location.physicalZip != null && props.data.location.physicalCountry != null && props.data.location.physicalCity) {
            const address = `${props.data.location.physicalStreet}, ${props.data.location.physicalCity}, ${props.data.location.physicalState} ${props.data.location.physicalZip}, ${props.data.location.physicalCountry}`
            const URL = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
            return window.open(URL, "_blank");
        }
    };

    if (loading) {
        return <Loading />;
    };

    return (
        <Grid
            container
            spacing={2}
        >
            <Grid item xs={10} md={10} lg={10}>
                <DetailPanel expandable>
                    <DetailPanelData title="LOCATION NAME" data={props.data.location.locationName} />
                    <DetailPanelData title="PREFERRED VENDOR" data={props.data.prefferedVendor} />
                    <DetailPanelData title="NAICS BUSINESS TYPE CODE" data={props.data.location.naicsBusinessTypeCode} />
                    <DetailPanelData title="LOCATION TYPE" data={props.data.location.locationType === null ? '' : codes.locationTypes.find(f => f.value == props.data.location.locationType).name} />
                    <DetailPanelData
                        title="CLASSIFICATION"
                        data={
                            props.data.location.classification === null || !codes.instanceLocationClassifications.find(f => f.value == props.data.location.classification)
                            ? ''
                            : codes.instanceLocationClassifications.find(f => f.value == props.data.location.classification).name
                        }
                    />
                    <DetailPanelData title="STANDARD INDUSTRIAL CLASSIFICATION (SIC) CODE" data={props.data.location.sicCode} />
                    <DetailPanelData title="REGION / DIVISION" data={props.data.region} />
                    <DetailPanelData title="PRIMARY USAGE TYPE" data={props.data.location.primaryUsageType == null ? '' : codes.locationUsageType.find(f => f.value == props.data.location.primaryUsageType).name} />
                    <DetailPanelData title="AQMD ID" data={props.data.location.aqmdId} />
                    <DetailPanelData title="EPA ID" data={props.data.location.epaId} />
                    <DetailPanelData title="REF ID" data={props.data.location.refId} />
                    <DetailPanelData title="OPERATOR FEDERAL TAX IDENTIFICATION NUMBER" data={props.data.location.taxId} />
                    <DetailPanelData title="YEAR BUILT" data={props.data.location.yearBuilt} />
                    <DetailPanelData title="OPERATION DATE" data={FormatDate(props.data.location.operationDate)} />
                    <DetailPanelData title="OPERATION END DATE" data={FormatDate(props.data.location.operationEndDate)} />
                    <DetailPanelData title="GROSS AREA SQ FT" data={props.data.location.sqft} />
                    <DetailPanelData title="OCCUPANCY PERCENT" data={props.data.location.occupancy} />
                    <DetailPanelData title="CONSTRUCTION STATUS" data={props.data.location.constructionStatus == null ? '' : codes.constructionStatusType.find(f => f.value == props.data.location.constructionStatus).name} />
                    <DetailPanelData title="LOCATION CODE" data={props.data.location.code} />
                    <DetailPanelData title="TEMPORARY BUILDING" data={props.data.location.temporaryBuilding == true ? "Yes" : ""} />
                    <DetailPanelData title="FEDERAL PROPERTY" data={props.data.location.federalProperty == true ? "Yes" : ""} />
                    <DetailPanelData title="ADDITIONAL NOTES" data={props.data.location.notes} />
                    <DetailPanelData title="IS OFFSITE" data={props.data.location.isOffsite == true ? "Yes" : ""} />
                    <DetailPanelData title="LOCATION GWP" data={props.data.location.locationGWP} />
                    <DetailPanelData title="PROCESS GWP" data={props.data.location.processGWP} />
                    <DetailPanelData title="COMFORT GWP" data={props.data.location.comfortGWP} />
                    <DetailPanelData title="REFRIGERATION GWP" data={props.data.location.refrigerationGWP} />
                    <DetailPanelData title="ADDRESS" data={formatAddress()} isClickable={formatAddress() !== 'N/A'} onClick={() => openAddressMap()} />
                    <DetailPanelData title="LATITUDE/LONGITUDE" data={formatLatLong()} isClickable={formatLatLong() !== 'N/A' } onClick={() => openLatLongMap()} />
                </DetailPanel>
            </Grid>

            {props.actionBoxItems.length > 0 && (
                <Grid item xs={2}>
                    <ActionBox
                        items={props.actionBoxItems}
                    />
                </Grid>
            )}
        </Grid>
    );
};

export default LocationHeader;
